<template>
    <!-- main-header-->
    <header class="main-header">
        <router-link to="/" class="logo-holder">
            <img :src="logoUrl" :alt="siteName">
        </router-link>
        <!-- nav-button-wrap-->
        <div class="nav-button but-hol">
            <span class="nos"></span>
            <span class="ncs"></span>
            <span class="nbs"></span>
            <div class="menu-button-text">Menu</div>
        </div>
        <!-- nav-button-wrap end-->			
        <div class="progress-bar-wrap">
            <div class="progress-bar color-bg"></div>
        </div>
        <div class="header_social" v-if="socialLinks.length">
            <ul>
                <li v-for="(link, index) in socialLinks" :key="index">
                    <a :href="link.url" target="_blank">{{ link.label }}</a>
                </li>
            </ul>
        </div>
        <!-- share-button -->
        <div class="folio-btn showshare">
            <div class="folio-btn-item"></div>
            <span class="folio-btn-tooltip">Share</span>
        </div>
        <!-- share-button end -->
    </header>
    <!-- main-header end-->
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'MainHeader',
    data() {
        return {
            siteDefaultsStore: null,
            logoUrl: '/assets/img/logo.png',
            siteName: '',
            socialLinks: []
        }
    },
    async mounted() {
        this.siteDefaultsStore = useSiteDefaultsStore()
        
        // Load initial data
        this.updateFromStore()
        
        // Listen for site defaults updates
        this.siteDefaultsStore.onSiteDefaultsLoaded(() => {
            this.updateFromStore()
        })
    },
    beforeUnmount() {
        if (this.siteDefaultsStore) {
            this.siteDefaultsStore.offAllEvents()
        }
    },
    methods: {
        updateFromStore() {
            if (this.siteDefaultsStore) {
                this.logoUrl = this.siteDefaultsStore.getLogoLight() || '/assets/img/logo.png'
                this.siteName = this.siteDefaultsStore.getSiteName() || 'Upatto'
                
                // Format social links for header display
                const links = this.siteDefaultsStore.getSocialLinks() || []
                this.socialLinks = links.map(link => ({
                    url: link.link || link.url || '#',
                    label: this.getSocialLabel(link.icon)
                })).slice(0, 4) // Only show first 4
            }
        },
        
        getSocialLabel(icon) {
            // Map icon names to short labels
            const labelMap = {
                'fab fa-facebook-f': 'Fb',
                'fab fa-twitter': 'Tw',
                'fab fa-instagram': 'In',
                'fab fa-behance': 'Be',
                'fab fa-linkedin-in': 'In',
                'fab fa-pinterest': 'Pi',
                'fab fa-youtube': 'Yt'
            }
            
            const iconLower = (icon || '').toLowerCase()
            return labelMap[iconLower] || icon.substring(0, 2).toUpperCase()
        }
    }
}
</script>

